import {
  CompanyFeaturesEnum,
  DEVELOPERS_PLAN,
  isCompanyTrialPlan,
} from '../../../models/api/company/companyModel';
import {CommonAppState} from '../../commonAppState';
import {createCommonSelector} from '../../helpers/commonReselectHelpers';

export function getCommonCompany(state: CommonAppState) {
  return state.data.company;
}

export function getCompanyUrl(state: CommonAppState) {
  return state.data.company.url;
}

export function getTicketingPreferences(state: CommonAppState) {
  return state.data.company.preferences.ticketing;
}

export function getCompanyHasTicketStatusesFeature(state: CommonAppState) {
  return state.data.company.features.includes(CompanyFeaturesEnum.TICKET_STATUSES);
}

export function getCompanyHasTicketIdsFeature(state: CommonAppState) {
  return state.data.company.features.includes(CompanyFeaturesEnum.TICKET_IDS);
}

export function getIsCustomer(state: CommonAppState) {
  const company = getCommonCompany(state);

  // Company is a customer if they are not on a trial plan.
  return company.plan !== undefined && !isCompanyTrialPlan(company.plan) && company.plan !== DEVELOPERS_PLAN;
}

export function getCompanyHasInviteOptionalBrandingFeature(state: CommonAppState) {
  return state.data.company.features.includes(CompanyFeaturesEnum.INVITE_OPTIONAL_BRANDING);
}

// Used to make certain Activation related features easier to manually test.
// You should avoid using this getIsFrontTestCompany selector whenever possible.
export const getIsFrontTestCompany = createCommonSelector([getCommonCompany], (company) =>
  /^frontTestCompany-/.test(company.name),
);
